import { request } from './http'

export interface SetupPayoffItem {
  id: string
  title: string
  target_chapter: number
  overdue_by_chapters: number
}

export interface WordBudgetProgress {
  total_chapters: number
  volume_number: number
  volume_start_chapter: number
  volume_end_chapter: number
  volume_chapter_count: number
  chapter_index_in_volume: number
  volume_budget_words: number
}

export interface StoryState {
  current_chapter_number: number
  current_volume_number: number
  overdue_foreshadows: SetupPayoffItem[]
  overdue_subplots: SetupPayoffItem[]
  convergence_density: number
  word_budget: WordBudgetProgress
  context_digest_summary: string
}

export interface StoryStateParams {
  branchId?: string | null
  chapter?: number | null
}

export interface StoryStateTrendPoint {
  chapter_no: number
  foreshadow_resolved: number
  foreshadow_overdue: number
  subplot_density: number
}

export interface StoryStateTrend {
  points: StoryStateTrendPoint[]
}

export interface StoryStateTrendParams {
  branchId?: string | null
  from: number
  to: number
}

const path = (projectId: string, params: StoryStateParams = {}) => {
  const qs = new URLSearchParams()
  if (params.branchId) qs.set('branch_id', params.branchId)
  if (params.chapter) qs.set('chapter', String(params.chapter))
  const suffix = qs.toString() ? `?${qs.toString()}` : ''
  return `/v1/projects/${encodeURIComponent(projectId)}/story-state${suffix}`
}

const trendPath = (projectId: string, params: StoryStateTrendParams) => {
  const qs = new URLSearchParams()
  if (params.branchId) qs.set('branch_id', params.branchId)
  qs.set('from', String(params.from))
  qs.set('to', String(params.to))
  return `/v1/projects/${encodeURIComponent(projectId)}/story-state/trend?${qs.toString()}`
}

export const storyStateApi = {
  get: (projectId: string, params?: StoryStateParams): Promise<StoryState> =>
    request<StoryState>(path(projectId, params)),

  getTrend: (projectId: string, params: StoryStateTrendParams): Promise<StoryStateTrend> =>
    request<StoryStateTrend>(trendPath(projectId, params)),
}
